import styled, { css } from "styled-components";
import Col from "react-bootstrap/Col";
import { getImageURL } from "../../utilities";
const StyledCard = styled(Col)`
  & {
    height: 32.5rem;
    position: relative;
    display: flex;
    flex-flow: column nowrap;
    padding: 1.25rem;
    margin: 0;
  }
    & .card-back-button{
        position: absolute;
    padding: 2px 8px 5px;
    font-size: 16px;
    left: 2rem;
    background-color: transparent;
    color: blue;
    border: none;
    font-weight: 600;
    }
  &.big {
    height: 18rem;
  }
  & .card-box {
    height: 100%;
    background: #ffffff;
    box-sizing: padding-box;
    box-shadow: 0px 4px 50px rgba(0, 0, 0, 0.25);
    overflow: hidden;
    border-radius: 10px;
  }
  & .card-title-box {
    height: 6.5rem;
    display: flex;
    margin: 0;
    padding: 0;
    justify-content: center;
    align-items: flex-start;
    background-repeat: no-repeat;
    background-position: top;
    background-size: 102% 100%;
  }
  &.small .card-title-box {
    background-image: url(${({ $smallHeaderImage }) =>
    getImageURL($smallHeaderImage)});
  }
  &.big .card-title-box {
    background-image: url(${({ $bigHeaderImage }) =>
    getImageURL($bigHeaderImage)});
  }
  & .card-title {
    text-wrap: balance;
    margin-inline: 1rem;
    font-family: "Poppins";
    font-style: normal;
    font-weight: 500;
    font-size: 23px;
    line-height: 27px;
    text-align: center;
    color: #ffffff;
    height: 4.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  & .card-content-box {
    padding: 1rem 1.25rem;
  }
  & .card-content {
    font-family: "Poppins";
    font-style: normal;
    font-weight: 300;
    font-size: 19px;
    line-height: 27px;
    text-align: justify;
    color: #083f88;
  }
  &.big.card-col .card-content br:last-of-type {
    display: none;
  }
  & .card-link {
    display: block;
    font-family: "Poppins";
    font-style: normal;
    font-weight: 400;
    font-size: 19px;
    line-height: 27px;
    text-align: left;
    text-decoration-line: underline;
    color: #041c68;
  }
  & .space {
    margin: 0.5rem 0;
  }
  & ul {
    list-style: none;
  }
  & ul li {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
  }
  & ul li::before {
    content: "•";
    color: red;
    font-weight: bold;
    display: inline-block;
    width: 1em;
    margin-left: -1em;
    color: #041c68;
  }
  &.big.card-col .card-content {
    text-align: center;
  }
  &.big.card-col li {
    display: flex;
    justify-content: center;
  }
  @media (max-width: 1699px) {
    & {
      padding: 1rem;
    }
    & {
      height: 34rem;
    }
    & .card-link {
      font-size:16px;
    }
  }
  @media (max-width: 1400px) {
    & {
      padding: 1rem;
    }
    &.big {
      height: 16rem;
    }
    & {
      height: 32rem;
    }
    & .card-title {
      font-size: 21px;
      line-height: 23px;
    }
    & .card-content-box {
      padding: 0.5rem 1rem;
    }
    & .card-content {
      font-size: 17px;
      line-height: 23px;
    }
    & .card-link {
      font-size: 13.5px;
      line-height: 23px;
    }
  }
    @media (min-width: 1200px) {
        & .card-back-button{
    top: 6rem !important;
       } 
    }
  @media (max-width: 1200px) {
    & {
      height: 28rem;
    }
      
    & .card-title-box {
      height: 6rem;
      background-size: 102% 100%;
    }
    &.big.card-col .card-title-box {
      background-size: 130% 100%;
    }
  }
    @media (min-width: 768px) {
& .expandable-items{
    height: 350px;
    overflow: hidden;
    overflow-y: scroll;   
    }
 & .card-back-button{
    top: 5.5rem;
       }
}

  @media (max-width: 991px) {
    & {
      height: 30.5rem;
    }
    
    & .card-link {
      font-size: 12px;
      line-height: 23px;
    }
    & .card-title-box {
      height: 6rem;
      background-size: 102% 100%;
    }
    & .card-title {
      margin-inline: 0.5rem;
    }
    &.big.card-col .card-content br {
      display: none;
    }
    & ul {
      transform: translateX(-0.5rem);
    }
  }
  @media (max-width: 767px) {
    & .card-link {
      font-size: 13.5px;
      line-height: 23px;
    }
         & .card-back-button{
    top: 6.3rem;
       }
    & {
      padding: 1rem;
      min-height: 19rem;
      height: auto;
    }
    &.big {
      min-height: 19rem;
      height: auto;
    }
    &.big.card-col .card-title-box {
      height: 7rem;
    }
    &.big.card-col .card-title {
      margin-top: 0.25rem;
    }
    &.big.card-col .card-content {
      text-align: left;
    }
    &.big.card-col li {
      display: flex;
      justify-content: flex-start;
    }
    &.card-col .card-title-box {
      background-image: url(${({ $smallHeaderImage }) =>
    getImageURL($smallHeaderImage)}) !important;
      background-size: 102% 117% !important;
      background-position: bottom;
    }
    &.big.card-col .card-content br {
      display: unset;
    }
    &.big.card-col .card-content br:last-of-type {
      display: unset;
    }
  }
  @media (max-width: 575px) {
    & .card-title {
      font-size: 18px;
      line-height: 23px;
    }
    &.card-col .card-title-box {
      padding-top: 0;
      height: 7rem;
      background-size: 132% 105% !important;
    }
  }
  @media (max-width: 350px) {
    &.card-col .card-title-box {
      background-size: 132% 105% !important;
    }
  }

  ${props =>
    props.$isDpaCard &&
    css`
    &.big {
      height: auto !important;
    }
      &.big.card-col li {
        display: block;
      }
      & ul {
        padding-bottom: 0rem;
      }
      & ul li {
        display: flex;
        justify-content: flex-start;
      }

      &.big.card-col ul {
        padding-bottom: 0rem;
      }

      @media (max-width: 767px) {
        &.big {
          height: auto !important;
        }
        &.big.card-col li {
          display: block !important;
        }
        & ul li {
          display: flex;
          justify-content: flex-start;
        }
      }
    `}

`;
export default StyledCard;